import React, { useEffect, useState } from 'react';
import authApiService from '../../../services/authServices';
import DataTable from "react-data-table-component";
import { useNavigate } from 'react-router-dom';
import Modal from '../../../utils/modalUtils';



const AdministrativeInbox = () => {
    const [inboxData, setInboxData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const navigate = useNavigate();



    useEffect(() => {
        fetchInboxData();
    }, []);

    const fetchInboxData = async () => {
        try {
            const response = await authApiService.get('getAdminInbox');
            setInboxData(response.data); 
        } catch (error) {
            console.error('Failed to fetch inbox data:', error);
        }
    };

    const formatDate = (date) => {
        if (!date) return "N/A";
        const d = new Date(date);
        return isNaN(d.getTime()) ? "N/A" : d.toISOString().split("T")[0];
    };

    /**
     * Handles deletion of selected messages with confirmation
     */
    const handleDeleteMessage = async () => {
        try {
            if (selectedRows.length === 0) {
                Modal.fire({
                    icon: 'warning',
                    title: 'No messages selected',
                    text: 'Please select at least one message to delete.',
                    confirmButtonText: 'OK'
                });
                return;
            }

            const confirmResult = await Modal.fire({
                title: 'Are you sure?',
                text: 'Do you really want to delete the selected message(s)?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#addd1e',
                cancelButtonColor: '#b38ec1',
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'Cancel'
            });

            if (!confirmResult.isConfirmed) return;

            const idsToDelete = selectedRows.map(row => row.id);
            const response = await authApiService.put('deleteAdministrateInbox', { id: idsToDelete });

            if (response.code === 200) {
                Modal.fire({
                    icon: "success",
                    title: "Deleted!",
                    text: "Message(s) deleted successfully.",
                    confirmButtonText: "OK",
                    confirmButtonColor: "#addd1e"
                });
                fetchInboxData(); 
                setSelectedRows([]);
            }
        } catch (error) {
            console.error('Failed to delete messages:', error);
            Modal.fire({
                icon: 'error',
                title: 'Error!',
                text: error.response?.data?.message || 'Failed to delete message(s)',
                confirmButtonText: 'OK',
                confirmButtonColor: '#addd1e'
            });
        }
    };






    const columns = [
        {
            name: 'From',
            cell: row => (
                <span
                    onClick={() =>
                        navigate('/carter/administrateInbox/AdminMessageInbox', {
                            state: { inboxItem: row }
                        })
                    }
                    style={{ cursor: 'pointer', textDecoration: 'underline' }}
                >
                    {row.sender}
                </span>
            ),
            sortable: true,
        },
        {
            name: 'To',
            cell: row => (
                <span
                    onClick={() =>
                        navigate('/carter/administrateInbox/AdminMessageInbox', {
                            state: { inboxItem: row }
                        })
                    }
                    style={{ cursor: 'pointer', textDecoration: 'underline' }}
                >
                    {row.receiverName}
                </span>
            ),
            sortable: true,
        },
        {
            name: 'Subject',
            cell: row => (
                <span
                    onClick={() =>
                        navigate('/carter/administrateInbox/AdminMessageInbox', {
                            state: { inboxItem: row }
                        })
                    }
                    style={{ cursor: 'pointer', textDecoration: 'underline' }}
                >
                    {row.subject}
                </span>
            ),
            sortable: true,
        },
        {
            name: 'Date',
            selector: row => formatDate(row.read_date),
            sortable: true,
        },

    ];

    const customStyles = {
        table: {
            style: {
                border: "1px solid #ddd",
            },
        },
        headRow: {
            style: {
                backgroundColor: "#40444d", 
                color: "#ffffff", 
            },
        },
        headCells: {
            style: {
                '& input[type="checkbox"]': {
                    display: 'none', 
                },
            },
        },
        rows: {
            style: {
                "&:nth-of-type(odd)": {
                    backgroundColor: "#dedfdd", 
                },
                "&:nth-of-type(even)": {
                    backgroundColor: "#ffffff",
                },
            },
        },
    };


    return (
        <div className="page-container col-12 mb-5">
            <DataTable
                columns={columns}
                data={inboxData}
                selectableRows
                customStyles={customStyles}
                onSelectedRowsChange={(state) => setSelectedRows(state.selectedRows)} 
                pagination
                highlightOnHover
                striped
                persistTableHead
            />
            <p className='mb-5 pb-4'>
                <button className="btn btn-danger" onClick={handleDeleteMessage}>
                    Delete Message
                </button>
            </p>


        </div>
    );
}

export default AdministrativeInbox